import M$control$LegendStyle from './/facade/js/legendStyle';
import M$control$LineStringStyle from './/facade/js/lineStringStyle';
import M$control$PointStyle from './/facade/js/pointStyle';
import M$control$PolygonStyle from './/facade/js/polygonStyle';
import M$plugin$StyleTools from './/facade/js/styletools';
import M$control$TextStyle from './/facade/js/textStyle';
import M$impl$control$LegendStyleImpl from './/impl/ol/js/legendStyle';
import M$impl$control$LineStringStyleImpl from './/impl/ol/js/lineStringStyle';
import M$impl$control$PointStyleImpl from './/impl/ol/js/pointStyle';
import M$impl$control$PolygonStyleImpl from './/impl/ol/js/polygonStyle';
import M$impl$control$TextStyleImpl from './/impl/ol/js/textStyle';

if (!window.M.control) window.M.control = {};
if (!window.M.plugin) window.M.plugin = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.control.LegendStyle = M$control$LegendStyle;
window.M.control.LineStringStyle = M$control$LineStringStyle;
window.M.control.PointStyle = M$control$PointStyle;
window.M.control.PolygonStyle = M$control$PolygonStyle;
window.M.plugin.StyleTools = M$plugin$StyleTools;
window.M.control.TextStyle = M$control$TextStyle;
window.M.impl.control.LegendStyleImpl = M$impl$control$LegendStyleImpl;
window.M.impl.control.LineStringStyleImpl = M$impl$control$LineStringStyleImpl;
window.M.impl.control.PointStyleImpl = M$impl$control$PointStyleImpl;
window.M.impl.control.PolygonStyleImpl = M$impl$control$PolygonStyleImpl;
window.M.impl.control.TextStyleImpl = M$impl$control$TextStyleImpl;
